module.exports = __webpack_public_path__ + "img/amount.d270dd24.svg";